import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import {
  DAYS_AGO,
  DEST_USDT,
  DIFF_VALUE,
  HAVAH_ROUTE_URL_LIVE,
  ORIGIN_TOKEN, SELECT_FORM_STYLE,
  STATISTICS_TRANSACTION_TYPES
} from '../../../../constants/base';
import { useDispatch } from 'react-redux';
import {
  statisticsTokenExcelDataRequest,
  statisticsTokenListRequest
} from '../../../../redux/actions/monitoring/statisticsActions';
import axios from 'axios';
import commonIcons from '../../../../api/images/icons';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers';
import TextField from '@mui/material/TextField';
import BtnIcons from '../../../../api/images/btnIcons';
import SimpleLine from '../ChartComponents/SimpleLine';
import Notification from '../../../../components/Notification/Notification';
import timeFormAPI from '../../../../api/ui/timeFormAPI';
import { convertBigNumToDecimalString } from '../../../../utils/convert-decimal-to-big-num';
import excelDownload from '../../../../api/excelDownload/excelDownload';
import sortKey from '../../../../api/excelDownload/sortKey';
import BOTable from "../../../../components/Tables/BOTable";
import useSchemaMonitoringTokenCC from "../../../../schema/table-schema/useSchemaMonitoringTokenCC";
import useSchemaMonitoringTokenEX from "../../../../schema/table-schema/useSchemaMonitoringTokenEX";
import FetchLoading from "../../../../components/Loading/FetchLoading";
import {
  SearchBtnContainer,
  SearchContainer,
  SearchContent,
  SearchDateRange,
  SearchLabel,
  SearchRow
} from "../../../../components/Search/searchSection";
import DataItem from "../DataItem";

function TokenMain() {
  // -- component const --//
  const title = '토큰';

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();

  // -- state --//
  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  // 토큰 종류
  const [activeTokenTab, setActiveTokenTab] = useState({
    XPER: true,
    PER: true,
    HVH: true,
    USDT: true,
    ARB: true,
  });

  const transactionTypes = STATISTICS_TRANSACTION_TYPES?.map((types) => ({
    key: types?.value.toString(),
    value: types?.key.toString(),
  }));

  const [Type, setTypes] = useState([]);

  // 날짜 범위
  const [activeDateRangeToken, setActiveDateRangeToken] = useState(7);
  const [startAt, setStartAt] = useState(DAYS_AGO(activeDateRangeToken));
  const [endAt, setEndAt] = useState(DAYS_AGO(1));

  // 데이터 설정
  const [userToken, setUserToken] = useState([{}]);
  const [tableData, setTableData] = useState([{}]);
  const [xPerToUsdt, setXperToUsdt] = useState([{}]);
  const [perToUsdt, setPerToUsdt] = useState([{}]);
  const [ExchangeRateData, setExchangeRateData] = useState([{}]);
  const [lineData, setLineData] = useState([{}]);
  const [lineExData, setLineExData] = useState([{}]);

  // Excel Data
  const [excelData, setExcelData] = useState();

  // 로딩
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingGraphCC, setIsLoadingGraphCC] = useState(false);
  const [isLoadingGraphEx, setIsLoadingGraphEx] = useState(false);

  // -- func & handler --//
  const handleChange = (event) => {
    const value = event.target.value;

    if (value.includes('all')) {
      setTypes(
        Type.length ===
          transactionTypes.filter(
            (item) => item.value !== '-9999' && item.value !== '-9998',
          ).length
          ? []
          : transactionTypes
              .filter(
                (item) => item.value !== '-9999' && item.value !== '-9998',
              )
              .map((item) => item.value),
      );
    } else {
      setTypes(value);
    }
  };

  const fetchList = () => {
    setIsLoadingGraphCC(true);
    setIsLoadingGraphEx(true);

    dispatch(
      statisticsTokenListRequest({
        beginDate: startAt,
        endDate: endAt,
        transactionType: Type.map((item) => String(item)).join(','),
        callback: (data) => {
          console.log('요청 결과: ', data);
          // setData(data?.graphData);
          // setTokenExchangeRateData(data?.exchangeRateData);

          // 토큰 생성 & 소비 현황 그래프 데이터 업데이트
          const updateLineData = formatGraphData(
            data?.graphData,
            activeTokenTab,
            'tokenCreatedConsumed',
          );
          setLineData(updateLineData);

          // 캐시북 적용 환율 그래프 데이터 업데이트
          const updateLineExData = formatGraphData(
            data?.exchangeRateData,
            activeTokenTab,
            'exchangeRate',
          );
          setLineExData(updateLineExData);

          setIsLoadingGraphCC(false);
          setIsLoadingGraphEx(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoadingGraphCC(false);
          setIsLoadingGraphEx(false);
        },
      }),
    );

    // 조회 버튼 눌리면 엑셀 범위 재설정
    // dispatch(
    //   statisticsTokenExcelDataRequest({
    //     beginDate: startAt,
    //     endDate: endAt,
    //     callback: (data) => {
    //       console.log('요청 결과: ', data);
    //       setExcelData(data?.list);
    //     },
    //     error: (e) => {
    //       console.log(e);
    //       setNotificationMessage(e.toString());
    //       setShowNotification(true);
    //     },
    //   })
    // )
  };

  // const handleClickDownload = () => {
  //   // 파일 명 설정
  //   const fileName = `토큰_${startAt}_${endAt}`;
  //
  //   excelDownload(fileName, excelData, sortKey.statistics.token);
  // };

  // 그래프 데이터 가공 함수
  const formatGraphData = (data, activeTokenTab, graphType) => {
    return data?.map((item) => {
      const newDate = timeFormAPI.changeDataDate(
        item?.targetDate || item?.timestamp,
      );
      const result = { time: newDate };

      if (graphType === 'tokenCreatedConsumed') {
        // 토큰 생성 & 소비 현황 그래프
        const consumedHvh =
          parseFloat(convertBigNumToDecimalString(item?.consumedHvh, 2)) || 0;
        const consumedPer =
          parseFloat(convertBigNumToDecimalString(item?.consumedPer, 2)) || 0;
        const consumedXper =
          parseFloat(convertBigNumToDecimalString(item?.consumedXper, 2)) || 0;
        const consumedUsdt = parseFloat(item?.consumedUsdt / 10 ** 6, 2) || 0;
        const consumedArb =
          parseFloat(convertBigNumToDecimalString(data?.consumedArb, 2)) || 0;

        const createdHvh =
          parseFloat(convertBigNumToDecimalString(item?.createdHvh, 2)) || 0;
        const createdPer =
          parseFloat(convertBigNumToDecimalString(item?.createdPer, 2)) || 0;
        const createdXper =
          parseFloat(convertBigNumToDecimalString(item?.createdXper, 2)) || 0;
        const createdUsdt = parseFloat(item?.createdUsdt / 10 ** 6, 2) || 0;
        const createdArb =
          parseFloat(convertBigNumToDecimalString(data?.createdArb, 2)) || 0;

        if (activeTokenTab['XPER']) {
          result['XPER 생성'] = createdXper;
          result['XPER 소비'] = consumedXper;
        }

        if (activeTokenTab['PER']) {
          result['PER 생성'] = createdPer;
          result['PER 소비'] = consumedPer;
        }

        if (activeTokenTab['HVH']) {
          result['HVH 생성'] = createdHvh;
          result['HVH 소비'] = consumedHvh;
        }

        if (activeTokenTab['USDT']) {
          result['USDT 생성'] = createdUsdt;
          result['USDT 소비'] = consumedUsdt;
        }

        if (activeTokenTab['ARB']) {
          result['ARB 생성'] = createdArb;
          result['ARB 소비'] = consumedArb;
        }
      } else if (graphType === 'exchangeRate') {
        // 캐시북 적용 환율 그래프
        const xperToUsdt = item?.xperToUsdt || 0;
        const perToUsdt = item?.perToUsdt || 0;
        const hvhToUsdt = item?.hvhToUsdt || 0;
        const arbToUsdt = item?.arbToUsdt || 0;

        if (activeTokenTab['XPER']) {
          result['XPER 가격'] = xperToUsdt;
        }

        if (activeTokenTab['PER']) {
          result['PER 가격'] = perToUsdt;
        }

        if (activeTokenTab['HVH']) {
          result['HVH 가격'] = hvhToUsdt;
        }

        if (activeTokenTab['ARB']) {
          result['ARB 가격'] = arbToUsdt;
        }
      }

      return result;
    });
  };

  // -- react hooks --//
  useEffect(() => {
    setStartAt(DAYS_AGO(activeDateRangeToken));
    setEndAt(DAYS_AGO(1));
  }, [activeDateRangeToken]);

  useEffect(() => {
    setIsLoading(true);

    // 토큰 생성 & 소비 현황 & 캐시북 적용 환율 조회
    dispatch(
      statisticsTokenListRequest({
        beginDate: startAt,
        endDate: DAYS_AGO(1),
        transactionType: Type.map((item) => String(item)).join(','),
        callback: (data) => {
          console.log('요청 결과: ', data);

          // 상단 인앱 토큰 현황
          setUserToken(data?.tokenData);

          const newExchangeRate = data?.exchangeRateData[data?.exchangeRateData.length - 1];

          // 토큰 가격
          setExchangeRateData({
            hvhToUsdt: newExchangeRate?.hvhToUsdt,
            perToUsdt: newExchangeRate?.perToUsdt,
            xperToUsdt: newExchangeRate?.xperToUsdt,
            arbToUsdt: newExchangeRate?.arbToUsdt,
          });

          // 토큰 생성 & 소비 현황 그래프 데이터 업데이트
          const updateLineData = formatGraphData(
            data?.graphData,
            activeTokenTab,
            'tokenCreatedConsumed',
          );
          setLineData(updateLineData);

          // 캐시북 적용 환율 그래프 데이터 업데이트
          const updateLineExData = formatGraphData(
            data?.exchangeRateData,
            activeTokenTab,
            'exchangeRate',
          );
          setLineExData(updateLineExData);

          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoading(false);
        },
      }),
    );

    // dispatch(
    //   statisticsTokenExcelDataRequest({
    //     beginDate: startAt,
    //     endDate: endAt,
    //     callback: (data) => {
    //       console.log('요청 결과: ', data);
    //       setExcelData(data?.list);
    //     },
    //     error: (e) => {
    //       console.log(e);
    //       setNotificationMessage(e.toString());
    //       setShowNotification(true);
    //     },
    //   })
    // );

    // DEX 현황: 유동성 풀및 토큰 가격
    // const DATA_PER = {
    //   amount: 10 ** 18,
    //   dest: DEST_USDT,
    //   origin: ORIGIN_TOKEN.LIVE.PER,
    //   side: 'Positive',
    //   singleRoute: true,
    // };
    //
    // const DATA_XPER = {
    //   amount: 10 ** 18,
    //   dest: DEST_USDT,
    //   origin: ORIGIN_TOKEN.LIVE.XPER,
    //   side: 'Positive',
    //   singleRoute: true,
    // };

    // axios
    //   .post(HAVAH_ROUTE_URL_LIVE, DATA_XPER)
    //   .then((res) => {
    //     setXperToUsdt({
    //       xPer:
    //         res.data?.poolPath[0]?.balances
    //           .cx845d39382f26509a4db7af8e3b38159f9c533852 /
    //           10 ** 18 || {},
    //       usdt:
    //         res.data?.poolPath[0]?.balances
    //           .cx3a60a0435b1c11265d69994188f33f043a789397 /
    //           10 ** 6 || {},
    //     });
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });
    //
    // axios
    //   .post(HAVAH_ROUTE_URL_LIVE, DATA_PER)
    //   .then((res) => {
    //     setPerToUsdt({
    //       per:
    //         res.data?.poolPath[0]?.balances
    //           .cxd7fed2ae1d9b2314087520efe1870c33e5c5baa4 /
    //           10 ** 18 || {},
    //       usdt:
    //         res.data?.poolPath[0]?.balances
    //           .cx3a60a0435b1c11265d69994188f33f043a789397 /
    //           10 ** 6 || {},
    //     });
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });
  }, []);

  // 현황 데이터
  useEffect(() => {
    const updateData = userToken?.map((data) => {
      const userWalletBalanceHvh =
        convertBigNumToDecimalString(data?.userWalletBalanceHvh, 2) || 0;
      const userWalletBalancePer =
        convertBigNumToDecimalString(data?.userWalletBalancePer, 2) || 0;
      const userWalletBalanceXper =
        convertBigNumToDecimalString(data?.userWalletBalanceXper, 2) || 0;
      const userWalletBalanceUsdt =
        parseFloat(data?.userWalletBalanceUsdt / 10 ** 6, 2) || 0;
      const userWalletBalanceArb =
        convertBigNumToDecimalString(data?.userWalletBalanceArb, 2) || 0;

      const targetDate = data?.targetDate;

      return {
        userWalletBalanceHvh: userWalletBalanceHvh.toLocaleString(undefined, {
          maximumFractionDigits: 2,
        }),
        userWalletBalancePer: userWalletBalancePer.toLocaleString(undefined, {
          maximumFractionDigits: 2,
        }),
        userWalletBalanceXper: userWalletBalanceXper.toLocaleString(undefined, {
          maximumFractionDigits: 2,
        }),
        userWalletBalanceUsdt: userWalletBalanceUsdt.toLocaleString(undefined, {
          maximumFractionDigits: 2,
        }),
        userWalletBalanceArb: userWalletBalanceArb.toLocaleString(undefined, {
          maximumFractionDigits: 2,
        }),
        targetDate: targetDate,
      };
    });

    setTableData(updateData);
    console.log("tableData: ", updateData);
  }, [userToken]);

  return (
    <div className="page">
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <div className="topSection">
        <div className="leftSection">
          <p className="titleText">{title}</p>
        </div>
      </div>

      <div className="spaceDiv10" />



      {/*<p className="subTitleText">*/}
      {/*  DEX 현황: 유동성 풀및 토큰 가격 {`(${timeFormAPI.changeDataDate(DAYS_AGO(0))}) 기준`}*/}
      {/*</p>*/}

      {/*<div className="spaceDiv10"/>*/}

      {/*<div className="" style={{*/}
      {/*  display: 'flex',*/}
      {/*  gap: 5,*/}
      {/*  height: 'fit-content'*/}
      {/*}}>*/}

      {/*  <div className="contentsArea" style={{*/}
      {/*    width: '100%',*/}
      {/*    height: '100%'*/}
      {/*  }}>*/}

      {/*    <div className="contentTitle flex" style={{ justifyContent: 'center', padding: 5 }}>*/}

      {/*      <div>*/}
      {/*        XPER <img src={commonIcons.transferIcon} alt={"transferIcon"}/> USDT*/}
      {/*      </div>*/}

      {/*    </div>*/}

      {/*    <div className="sectionLine"/>*/}

      {/*    <div className="rowDiv" style={{ padding: 5 }}>*/}

      {/*      <p style={{*/}
      {/*        minWidth: 40,*/}
      {/*        fontSize: 14,*/}
      {/*        fontWeight: 400,*/}
      {/*        color: '#787878'*/}
      {/*      }}>*/}
      {/*        XPER*/}
      {/*      </p>*/}

      {/*      <p style={{*/}
      {/*        fontSize: 14,*/}
      {/*        fontWeight: 700,*/}
      {/*        color: '#141414'*/}
      {/*      }}>*/}
      {/*        {*/}
      {/*          xPerToUsdt.xPer?.toLocaleString(undefined, {*/}
      {/*            maximumFractionDigits: 2,*/}
      {/*          })*/}
      {/*        }*/}
      {/*      </p>*/}

      {/*    </div>*/}

      {/*    <div className="rowDiv" style={{ padding: 5 }}>*/}

      {/*      <p style={{*/}
      {/*        minWidth: 40,*/}
      {/*        fontSize: 14,*/}
      {/*        fontWeight: 400,*/}
      {/*        color: '#787878'*/}
      {/*      }}>*/}
      {/*        USDT*/}
      {/*      </p>*/}

      {/*      <p style={{*/}
      {/*        fontSize: 14,*/}
      {/*        fontWeight: 700,*/}
      {/*        color: '#141414'*/}
      {/*      }}>*/}
      {/*        {*/}
      {/*          xPerToUsdt.usdt?.toLocaleString(undefined, {*/}
      {/*            maximumFractionDigits: 2,*/}
      {/*          })*/}
      {/*        }*/}
      {/*      </p>*/}

      {/*    </div>*/}

      {/*  </div>*/}

      {/*  <div className="contentsArea" style={{*/}
      {/*    width: '100%',*/}
      {/*    height: '100%'*/}
      {/*  }}>*/}

      {/*    <div className="contentTitle flex" style={{ justifyContent: 'center', padding: 5 }}>*/}

      {/*      <div>*/}
      {/*        PER <img src={commonIcons.transferIcon} alt={"transferIcon"}/> USDT*/}
      {/*      </div>*/}

      {/*    </div>*/}

      {/*    <div className="sectionLine"/>*/}

      {/*    <div className="rowDiv" style={{ padding: 5 }}>*/}

      {/*      <p style={{*/}
      {/*        minWidth: 40,*/}
      {/*        fontSize: 14,*/}
      {/*        fontWeight: 400,*/}
      {/*        color: '#787878'*/}
      {/*      }}>*/}
      {/*        PER*/}
      {/*      </p>*/}

      {/*      <p style={{*/}
      {/*        fontSize: 14,*/}
      {/*        fontWeight: 700,*/}
      {/*        color: '#141414'*/}
      {/*      }}>*/}
      {/*        {*/}
      {/*          perToUsdt.per?.toLocaleString(undefined, {*/}
      {/*            maximumFractionDigits: 2,*/}
      {/*          })*/}
      {/*        }*/}
      {/*      </p>*/}

      {/*    </div>*/}

      {/*    <div className="rowDiv" style={{ padding: 5 }}>*/}

      {/*      <p style={{*/}
      {/*        minWidth: 40,*/}
      {/*        fontSize: 14,*/}
      {/*        fontWeight: 400,*/}
      {/*        color: '#787878'*/}
      {/*      }}>*/}
      {/*        USDT*/}
      {/*      </p>*/}

      {/*      <p style={{*/}
      {/*        fontSize: 14,*/}
      {/*        fontWeight: 700,*/}
      {/*        color: '#141414'*/}
      {/*      }}>*/}
      {/*        {*/}
      {/*          perToUsdt.usdt?.toLocaleString(undefined, {*/}
      {/*            maximumFractionDigits: 2,*/}
      {/*          })*/}
      {/*        }*/}
      {/*      </p>*/}

      {/*    </div>*/}

      {/*  </div>*/}

      {/*  <div className="contentsArea" style={{*/}
      {/*    width: '100%',*/}
      {/*    display: 'flex',*/}
      {/*    justifyContent: 'center',*/}
      {/*    alignItems: 'center'*/}
      {/*  }}>*/}

      {/*    <div className="contentTitle flex" style={{ justifyContent: 'center', padding: 5 }}>*/}

      {/*      <div style={{*/}
      {/*        fontWeight: 400,*/}
      {/*        color: '#999'*/}
      {/*      }}>*/}
      {/*        Coming Soon...*/}
      {/*      </div>*/}

      {/*    </div>*/}

      {/*  </div>*/}

      {/*  <div className="contentsArea" style={{*/}
      {/*    width: '100%',*/}
      {/*    display: 'flex',*/}
      {/*    justifyContent: 'center',*/}
      {/*    alignItems: 'center'*/}
      {/*  }}>*/}

      {/*    <div className="contentTitle flex" style={{ justifyContent: 'center', padding: 5 }}>*/}

      {/*      <div style={{*/}
      {/*        fontWeight: 400,*/}
      {/*        color: '#999'*/}
      {/*      }}>*/}
      {/*        Coming Soon...*/}
      {/*      </div>*/}

      {/*    </div>*/}

      {/*  </div>*/}

      {/*</div>*/}

      {/*<div className="spaceDiv10"/>*/}

      {/*<div className="" style={{*/}
      {/*  display: 'flex',*/}
      {/*  gap: 5,*/}
      {/*  height: 'fit-content'*/}
      {/*}}>*/}

      {/*  <div className="contentsArea" style={{*/}
      {/*    width: '100%',*/}
      {/*    height: '100%'*/}
      {/*  }}>*/}

      {/*    {*/}
      {/*      isLoading ? (*/}
      {/*          <div className="rowDiv" style={{*/}
      {/*            width: '100%',*/}
      {/*            height: '100%',*/}
      {/*            display: 'flex',*/}
      {/*            justifyContent: 'center',*/}
      {/*            padding: 5*/}
      {/*          }}>*/}
      {/*            Loading...*/}
      {/*          </div>*/}
      {/*        )*/}
      {/*        : (*/}
      {/*          <div>*/}
      {/*            <div className="rowDiv" style={{*/}
      {/*              width: '100%',*/}
      {/*              height: '100%',*/}
      {/*              padding: 5*/}
      {/*            }}>*/}

      {/*              <div style={{*/}
      {/*                display: 'flex',*/}
      {/*                flexDirection: 'column',*/}
      {/*                justifyContent: 'center',*/}
      {/*                width: '100%',*/}
      {/*                height: '100%'*/}
      {/*              }}>*/}
      {/*                <div style={{*/}
      {/*                  display: 'flex',*/}
      {/*                  gap: 5*/}
      {/*                }}>*/}

      {/*                  <div style={{*/}
      {/*                    width: '100%',*/}
      {/*                    fontSize: 14*/}
      {/*                  }}>*/}
      {/*                    <img src={commonIcons.xperIcon} style={{ width: 16 }} alt="xperIcon"/> XPER 현재 가격<br/>*/}
      {/*                    <p style={{*/}
      {/*                      fontSize: 16,*/}
      {/*                      fontWeight: 700,*/}
      {/*                      color: '#141414'*/}
      {/*                    }}>*/}
      {/*                      {*/}
      {/*                        xPerToUsdt.usdt / xPerToUsdt.xPer + ' USDT'*/}
      {/*                      }*/}
      {/*                    </p>*/}
      {/*                    {*/}
      {/*                      DIFF_VALUE(*/}
      {/*                        ExchangeRateData.xperToUsdt,*/}
      {/*                        xPerToUsdt.usdt / xPerToUsdt.xPer,*/}
      {/*                        DAYS_AGO(0)*/}
      {/*                      )*/}
      {/*                    }*/}
      {/*                  </div>*/}

      {/*                </div>*/}

      {/*              </div>*/}
      {/*            </div>*/}

      {/*          </div>*/}

      {/*        )*/}
      {/*    }*/}

      {/*  </div>*/}

      {/*  <div className="contentsArea" style={{*/}
      {/*    width: '100%',*/}
      {/*    height: '100%'*/}
      {/*  }}>*/}

      {/*    {*/}
      {/*      isLoading ? (*/}
      {/*          <div className="rowDiv" style={{*/}
      {/*            width: '100%',*/}
      {/*            height: '100%',*/}
      {/*            display: 'flex',*/}
      {/*            justifyContent: 'center',*/}
      {/*            padding: 5*/}
      {/*          }}>*/}
      {/*            Loading...*/}
      {/*          </div>*/}
      {/*        )*/}
      {/*        : (*/}
      {/*          <div>*/}
      {/*            <div className="rowDiv" style={{*/}
      {/*              width: '100%',*/}
      {/*              height: '100%',*/}
      {/*              padding: 5*/}
      {/*            }}>*/}

      {/*              <div style={{*/}
      {/*                display: 'flex',*/}
      {/*                flexDirection: 'column',*/}
      {/*                justifyContent: 'center',*/}
      {/*                width: '100%',*/}
      {/*                height: '100%'*/}
      {/*              }}>*/}
      {/*                <div style={{*/}
      {/*                  display: 'flex',*/}
      {/*                  gap: 5*/}
      {/*                }}>*/}

      {/*                  <div style={{*/}
      {/*                    width: '100%',*/}
      {/*                    fontSize: 14*/}
      {/*                  }}>*/}
      {/*                    <img src={commonIcons.perIcon} style={{ width: 16 }} alt="perIcon"/> PER 현재 가격<br/>*/}
      {/*                    <p style={{*/}
      {/*                      fontSize: 16,*/}
      {/*                      fontWeight: 700,*/}
      {/*                      color: '#141414'*/}
      {/*                    }}>*/}
      {/*                      {*/}
      {/*                        perToUsdt.usdt / perToUsdt.per + ' USDT'*/}
      {/*                      }*/}
      {/*                    </p>*/}
      {/*                    {*/}
      {/*                      DIFF_VALUE(*/}
      {/*                        ExchangeRateData.perToUsdt,*/}
      {/*                        perToUsdt.usdt / perToUsdt.per,*/}
      {/*                        DAYS_AGO(0)*/}
      {/*                      )*/}
      {/*                    }*/}
      {/*                  </div>*/}

      {/*                </div>*/}

      {/*              </div>*/}
      {/*            </div>*/}

      {/*          </div>*/}

      {/*        )*/}
      {/*    }*/}

      {/*  </div>*/}

      {/*</div>*/}


      <div className="contentsArea">

        <div className={"contentTitle"}>
          인앱 토큰 현황 {`(${timeFormAPI.changeDataDate(DAYS_AGO(1))} 기준)`}
        </div>

        {isLoading ? (
          <FetchLoading />
        ) : (
          tableData.slice(0, -1).map((data, index) => (
            <div key={index} style={{padding: "10px 15px"}}>
                  <div
                    style={{
                      display: 'flex',
                      gap: 5,
                    }}
                  >

                    <DataItem
                        label="PER"
                        value={tableData[index + 1]?.userWalletBalancePer}
                        prevValue={tableData[index]?.userWalletBalancePer}
                        targetDate={tableData[index + 1]?.targetDate}
                    />

                    <DataItem
                        label="XPER"
                        value={tableData[index + 1]?.userWalletBalanceXper}
                        prevValue={tableData[index]?.userWalletBalanceXper}
                        targetDate={tableData[index + 1]?.targetDate}
                    />

                    <DataItem
                        label="HVH"
                        value={tableData[index + 1]?.userWalletBalanceHvh}
                        prevValue={tableData[index]?.userWalletBalanceHvh}
                        targetDate={tableData[index + 1]?.targetDate}
                    />

                    <DataItem
                        label="USDT"
                        value={tableData[index + 1]?.userWalletBalanceUsdt}
                        prevValue={tableData[index]?.userWalletBalanceUsdt}
                        targetDate={tableData[index + 1]?.targetDate}
                    />

                    <DataItem
                        label="ARB"
                        value={tableData[index + 1]?.userWalletBalanceArb}
                        prevValue={tableData[index]?.userWalletBalanceArb}
                        targetDate={tableData[index + 1]?.targetDate}
                    />
                  </div>
            </div>
          ))
        )}
      </div>


      {/*<div className="contentsArea paddingAll">*/}
      {/*  <div className="rowDiv">*/}
      {/*    <div className="titleDiv flex-space-between">*/}
      {/*      <div className="left">토큰 지표 조회</div>*/}
      {/*    </div>*/}

      {/*    <div className="spaceDiv10" />*/}

      {/*    <div className="descDiv" style={{ alignItems: 'center' }}>*/}
      {/*      <FormControl id={'formController'}>*/}
      {/*        <Select*/}
      {/*          displayEmpty*/}
      {/*          multiple*/}
      {/*          value={Type}*/}
      {/*          onChange={handleChange}*/}
      {/*          renderValue={(selected) => {*/}
      {/*            if (selected.length === 0) {*/}
      {/*              return <div style={{ color: '#999' }}>트랜잭션 종류</div>;*/}
      {/*            }*/}

      {/*            return selected*/}
      {/*              .map(*/}
      {/*                (value) =>*/}
      {/*                  transactionTypes.find((item) => item?.value === value)*/}
      {/*                    ?.key,*/}
      {/*              )*/}
      {/*              .filter(Boolean)*/}
      {/*              .join(', ');*/}
      {/*          }}*/}
      {/*          style={SELECT_FORM_STYLE}*/}
      {/*        >*/}
      {/*          <MenuItem*/}
      {/*            value="all"*/}
      {/*            style={{*/}
      {/*              padding: 5,*/}
      {/*              gap: 5,*/}
      {/*            }}*/}
      {/*          >*/}
      {/*            <input*/}
      {/*              type="checkbox"*/}
      {/*              checked={*/}
      {/*                Type.length ===*/}
      {/*                transactionTypes.filter(*/}
      {/*                  (item) =>*/}
      {/*                    item.value !== '-9999' && item.value !== '-9998',*/}
      {/*                ).length*/}
      {/*              }*/}
      {/*              onChange={() => {}}*/}
      {/*              onClick={() => {*/}
      {/*                const allSelected =*/}
      {/*                  Type.length ===*/}
      {/*                  transactionTypes.filter(*/}
      {/*                    (item) =>*/}
      {/*                      item.value !== '-9999' && item.value !== '-9998',*/}
      {/*                  ).length;*/}
      {/*                setTypes(*/}
      {/*                  allSelected*/}
      {/*                    ? []*/}
      {/*                    : transactionTypes*/}
      {/*                        .filter(*/}
      {/*                          (item) =>*/}
      {/*                            item.value !== '-9999' &&*/}
      {/*                            item.value !== '-9998',*/}
      {/*                        )*/}
      {/*                        .map((item) => item.value),*/}
      {/*                );*/}
      {/*              }}*/}
      {/*            />*/}
      {/*            <ListItemText*/}
      {/*              primary="전체 선택"*/}
      {/*              onClick={() => {*/}
      {/*                const allSelected =*/}
      {/*                  Type.length ===*/}
      {/*                  transactionTypes.filter(*/}
      {/*                    (item) =>*/}
      {/*                      item.value !== '-9999' && item.value !== '-9998',*/}
      {/*                  ).length;*/}
      {/*                setTypes(*/}
      {/*                  allSelected*/}
      {/*                    ? []*/}
      {/*                    : transactionTypes*/}
      {/*                        .filter(*/}
      {/*                          (item) =>*/}
      {/*                            item.value !== '-9999' &&*/}
      {/*                            item.value !== '-9998',*/}
      {/*                        )*/}
      {/*                        .map((item) => item.value),*/}
      {/*                );*/}
      {/*              }}*/}
      {/*            />*/}
      {/*          </MenuItem>*/}
      {/*          {transactionTypes?.map((item) => (*/}
      {/*            <MenuItem*/}
      {/*              key={item?.value}*/}
      {/*              value={item?.value}*/}
      {/*              disabled={*/}
      {/*                item?.value === '-9999' || item?.value === '-9998'*/}
      {/*              }*/}
      {/*              style={{*/}
      {/*                padding: 5,*/}
      {/*                gap: 5,*/}
      {/*              }}*/}
      {/*            >*/}
      {/*              {item?.value !== '-9999' && item?.value !== '-9998' && (*/}
      {/*                <input*/}
      {/*                  type="checkbox"*/}
      {/*                  checked={Type.includes(item?.value)}*/}
      {/*                  onChange={(event) => {*/}
      {/*                    const checked = event.target.checked;*/}
      {/*                    setTypes((prevTypes) => {*/}
      {/*                      if (checked) {*/}
      {/*                        return [...new Set([...prevTypes, item.value])];*/}
      {/*                      } else {*/}
      {/*                        return prevTypes.filter(*/}
      {/*                          (value) => value !== item.value,*/}
      {/*                        );*/}
      {/*                      }*/}
      {/*                    });*/}
      {/*                  }}*/}
      {/*                />*/}
      {/*              )}*/}
      {/*              <ListItemText primary={item?.key} />*/}
      {/*            </MenuItem>*/}
      {/*          ))}*/}
      {/*        </Select>*/}
      {/*      </FormControl>*/}

      {/*      <div className="descDiv dateSmall">*/}
      {/*        <LocalizationProvider dateAdapter={AdapterMoment}>*/}
      {/*          <DatePicker*/}
      {/*            onChange={(date) => {*/}
      {/*              setStartAt(date.format('YYYY-MM-DD'));*/}
      {/*            }}*/}
      {/*            value={startAt}*/}
      {/*            renderInput={(params) => (*/}
      {/*              <TextField {...params} variant="standard" />*/}
      {/*            )}*/}
      {/*          />*/}
      {/*        </LocalizationProvider>*/}

      {/*        <LocalizationProvider dateAdapter={AdapterMoment}>*/}
      {/*          <DatePicker*/}
      {/*            onChange={(date) => {*/}
      {/*              setEndAt(date.format('YYYY-MM-DD'));*/}
      {/*            }}*/}
      {/*            value={endAt}*/}
      {/*            renderInput={(params) => (*/}
      {/*              <TextField {...params} variant="standard" />*/}
      {/*            )}*/}
      {/*          />*/}
      {/*        </LocalizationProvider>*/}
      {/*      </div>*/}

      {/*      <button*/}
      {/*        className={`dateSelectBox ${*/}
      {/*          activeDateRangeToken === 7 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeToken(7);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        주*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`dateSelectBox ${*/}
      {/*          activeDateRangeToken === 30 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeToken(30);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        월*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`dateSelectBox ${*/}
      {/*          activeDateRangeToken === 90 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeToken(90);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        3개월*/}
      {/*      </button>*/}

      {/*      /!*<button*!/*/}
      {/*      /!*  className={`dateSelectBox tokens ${activeTokenTab.XPER ? 'active' : ''}`}*!/*/}
      {/*      /!*  onClick={() => {*!/*/}
      {/*      /!*    setActiveTokenTab({*!/*/}
      {/*      /!*      ...activeTokenTab,*!/*/}
      {/*      /!*      XPER: !activeTokenTab.XPER,*!/*/}
      {/*      /!*    });*!/*/}
      {/*      /!*  }}*!/*/}
      {/*      /!*>*!/*/}
      {/*      /!*  <img*!/*/}
      {/*      /!*    src={commonIcons.xperIcon}*!/*/}
      {/*      /!*    alt={'xperIcon'}/>*!/*/}
      {/*      /!*  XPER*!/*/}
      {/*      /!*</button>*!/*/}
      {/*      /!*<button*!/*/}
      {/*      /!*  className={`dateSelectBox tokens ${activeTokenTab.PER ? 'active' : ''}`}*!/*/}
      {/*      /!*  onClick={() => {*!/*/}
      {/*      /!*    setActiveTokenTab({*!/*/}
      {/*      /!*      ...activeTokenTab,*!/*/}
      {/*      /!*      PER: !activeTokenTab.PER,*!/*/}
      {/*      /!*    });*!/*/}
      {/*      /!*  }}*!/*/}
      {/*      /!*>*!/*/}
      {/*      /!*  <img*!/*/}
      {/*      /!*    src={commonIcons.perIcon}*!/*/}
      {/*      /!*    alt={'perIcon'}/>*!/*/}
      {/*      /!*  PER*!/*/}
      {/*      /!*</button>*!/*/}
      {/*      /!*<button*!/*/}
      {/*      /!*  className={`dateSelectBox tokens ${activeTokenTab.HVH ? 'active' : ''}`}*!/*/}
      {/*      /!*  onClick={() => {*!/*/}
      {/*      /!*    setActiveTokenTab({*!/*/}
      {/*      /!*      ...activeTokenTab,*!/*/}
      {/*      /!*      HVH: !activeTokenTab.HVH,*!/*/}
      {/*      /!*    });*!/*/}
      {/*      /!*  }}*!/*/}
      {/*      /!*>*!/*/}
      {/*      /!*  <img*!/*/}
      {/*      /!*    src={commonIcons.hvhIcon}*!/*/}
      {/*      /!*    alt={'hvhIcon'}/>*!/*/}
      {/*      /!*  HVH*!/*/}
      {/*      /!*</button>*!/*/}
      {/*      /!*<button*!/*/}
      {/*      /!*  className={`dateSelectBox tokens ${activeTokenTab.USDT ? 'active' : ''}`}*!/*/}
      {/*      /!*  onClick={() => {*!/*/}
      {/*      /!*    setActiveTokenTab({*!/*/}
      {/*      /!*      ...activeTokenTab,*!/*/}
      {/*      /!*      USDT: !activeTokenTab.USDT,*!/*/}
      {/*      /!*    });*!/*/}
      {/*      /!*  }}*!/*/}
      {/*      /!*>*!/*/}
      {/*      /!*  <img*!/*/}
      {/*      /!*    src={commonIcons.usdtIcon}*!/*/}
      {/*      /!*    alt={'usdtIcon'}/>*!/*/}
      {/*      /!*  USDT*!/*/}
      {/*      /!*</button>*!/*/}
      {/*      /!*<button*!/*/}
      {/*      /!*    className={`dateSelectBox tokens ${activeTokenTab.ARB ? 'active' : ''}`}*!/*/}
      {/*      /!*    onClick={() => {*!/*/}
      {/*      /!*      setActiveTokenTab({*!/*/}
      {/*      /!*        ...activeTokenTab,*!/*/}
      {/*      /!*        ARB: !activeTokenTab.ARB,*!/*/}
      {/*      /!*      });*!/*/}
      {/*      /!*    }}*!/*/}
      {/*      /!*>*!/*/}
      {/*      /!*  <img*!/*/}
      {/*      /!*      src={commonIcons.arbIcon}*!/*/}
      {/*      /!*      alt={'arbIcon'}/>*!/*/}
      {/*      /!*  ARB*!/*/}
      {/*      /!*</button>*!/*/}

      {/*      <button*/}
      {/*        className="defaultBtn"*/}
      {/*        onClick={() => {*/}
      {/*          fetchList();*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        조회*/}
      {/*      </button>*/}

      {/*      /!*<button className="defaultBtn fit purple" onClick={handleClickDownload}>*!/*/}
      {/*      /!*  <img src={BtnIcons.downloadIcon} alt={'다운로드'}/>*!/*/}
      {/*      /!*  엑셀 다운로드*!/*/}
      {/*      /!*</button>*!/*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}

      <div className="spaceDiv10" />

      <SearchContainer>
        <SearchRow>
          <SearchLabel text={"날짜"}/>
          <SearchDateRange
              startAt={startAt}
              endAt={endAt}
              setStartAt={setStartAt}
              setEndAt={setEndAt}
          />
        </SearchRow>

        <SearchRow>
          <SearchLabel text={"트랜잭션 종류"}/>
          <SearchContent>
            <FormControl id={'formController'}>
              <Select
                  displayEmpty
                  multiple
                  value={Type}
                  onChange={handleChange}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return <div style={{ color: '#999' }}>트랜잭션 종류</div>;
                    }

                    return selected
                        .map(
                            (value) =>
                                transactionTypes.find((item) => item?.value === value)
                                    ?.key,
                        )
                        .filter(Boolean)
                        .join(', ');
                  }}
                  style={SELECT_FORM_STYLE}
              >
                <MenuItem
                    value="all"
                    style={{
                      padding: 5,
                      gap: 5,
                    }}
                >
                  <input
                      type="checkbox"
                      checked={
                          Type.length ===
                          transactionTypes.filter(
                              (item) =>
                                  item.value !== '-9999' && item.value !== '-9998',
                          ).length
                      }
                      onChange={() => {}}
                      onClick={() => {
                        const allSelected =
                            Type.length ===
                            transactionTypes.filter(
                                (item) =>
                                    item.value !== '-9999' && item.value !== '-9998',
                            ).length;
                        setTypes(
                            allSelected
                                ? []
                                : transactionTypes
                                    .filter(
                                        (item) =>
                                            item.value !== '-9999' &&
                                            item.value !== '-9998',
                                    )
                                    .map((item) => item.value),
                        );
                      }}
                  />
                  <ListItemText
                      primary="전체 선택"
                      onClick={() => {
                        const allSelected =
                            Type.length ===
                            transactionTypes.filter(
                                (item) =>
                                    item.value !== '-9999' && item.value !== '-9998',
                            ).length;
                        setTypes(
                            allSelected
                                ? []
                                : transactionTypes
                                    .filter(
                                        (item) =>
                                            item.value !== '-9999' &&
                                            item.value !== '-9998',
                                    )
                                    .map((item) => item.value),
                        );
                      }}
                  />
                </MenuItem>
                {transactionTypes?.map((item) => (
                    <MenuItem
                        key={item?.value}
                        value={item?.value}
                        disabled={
                            item?.value === '-9999' || item?.value === '-9998'
                        }
                        style={{
                          padding: 5,
                          gap: 5,
                        }}
                    >
                      {item?.value !== '-9999' && item?.value !== '-9998' && (
                          <input
                              type="checkbox"
                              checked={Type.includes(item?.value)}
                              onChange={(event) => {
                                const checked = event.target.checked;
                                setTypes((prevTypes) => {
                                  if (checked) {
                                    return [...new Set([...prevTypes, item.value])];
                                  } else {
                                    return prevTypes.filter(
                                        (value) => value !== item.value,
                                    );
                                  }
                                });
                              }}
                          />
                      )}
                      <ListItemText primary={item?.key} />
                    </MenuItem>
                ))}
              </Select>
            </FormControl>
          </SearchContent>

        </SearchRow>


      </SearchContainer>

      <SearchBtnContainer
          handleSearchClick={() => {
            fetchList();
          }}
          handleResetClick={() => {
            setStartAt(DAYS_AGO(activeDateRangeToken));
            setEndAt(DAYS_AGO(1));
            setTypes([]);
            fetchList();
          }}
      />



      <div className="spaceDiv10" />
      <div className="spaceDiv10" />
      <div className="spaceDiv10" />

        <div style={{fontSize: 16, fontWeight: "bold"}}>토큰 생성 & 소비 현황</div>

        <div className="spaceDiv10" />

        {/*{*/}
        {/*  isLoading || isLoadingGraphCC ? (*/}
        {/*    <div className="rowDiv" style={{*/}
        {/*      width: '100%',*/}
        {/*      height: 520,*/}
        {/*      display: 'flex',*/}
        {/*      justifyContent: 'center',*/}
        {/*      padding: 'unset'*/}
        {/*    }}>*/}
        {/*      Loading...*/}
        {/*    </div>*/}
        {/*  ) : <div className="rowDiv" style={{*/}
        {/*    height: 520,*/}
        {/*    padding: 'unset'*/}
        {/*  }}>*/}
        {/*    <div className="descDiv" style={{*/}
        {/*      width: '100%',*/}
        {/*      height: '100%'*/}
        {/*    }}>*/}
        {/*      <SimpleLine data={lineData}/>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*}*/}

        <BOTable
          schema={useSchemaMonitoringTokenCC()}
          rows={lineData}
          loading={isLoadingGraphCC}
          maxHeight={"30vh"}
        />
      {/* 토큰 생성 및 소비 현황 */}

      <div className="spaceDiv10" />
      <div className="spaceDiv10" />
      <div className="spaceDiv10" />

        <div style={{fontSize: 16, fontWeight: "bold"}}>캐시북 적용 환율</div>

        <div className="spaceDiv10" />

        {/*{*/}
        {/*  isLoading || isLoadingGraphEx ? (*/}
        {/*    <div className="rowDiv" style={{*/}
        {/*      width: '100%',*/}
        {/*      height: 520,*/}
        {/*      display: 'flex',*/}
        {/*      justifyContent: 'center',*/}
        {/*      padding: 'unset'*/}
        {/*    }}>*/}
        {/*      Loading...*/}
        {/*    </div>*/}
        {/*  ) : <div className="rowDiv" style={{*/}
        {/*    height: 520,*/}
        {/*    padding: 'unset'*/}
        {/*  }}>*/}
        {/*    <div className="descDiv" style={{*/}
        {/*      width: '100%',*/}
        {/*      height: '100%'*/}
        {/*    }}>*/}
        {/*      <SimpleLine data={lineExData}/>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*}*/}

        <BOTable
          rows={lineExData}
          schema={useSchemaMonitoringTokenEX()}
          loading={isLoadingGraphEx}
          maxHeight={"30vh"}
        />
      {/* 캐시북 적용 환율 */}

      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}
    </div>
  );
}

export default TokenMain;
